import {Cycle} from '@services/model/cycle';
import {HpOverviewStatsResource, VotingStatsResource} from '@services/resource/hp-overview-stats-resource';

export class VotingStats {
  constructor(
    public readonly current: Cycle | null,
    public readonly totalOutstandingVotes: number,
    public readonly next: Cycle | null,
  ) {}

  static fromResource(r: VotingStatsResource): VotingStats {
    return {
      current: r.cycle ? Cycle.fromResource(r.cycle) : null,
      totalOutstandingVotes: r.totalOutstandingVotes,
      next: r.nextCycle ? Cycle.fromResource(r.nextCycle) : null,
    };
  }
}

export class HpOverviewStats {
  constructor(
    public readonly totalProducts: number,
    public readonly totalRecentPitch: number,
    public readonly recentCycle: Cycle | undefined,
    /* those are all related to the publication date */
    public readonly nextCycle: Cycle | undefined,
    public readonly totalNextCycle: number | undefined,
    /* voting */
    public readonly voting: VotingStats | undefined /* undefined if no voting permission */,
  ) {}

  static fromResource(r: HpOverviewStatsResource): HpOverviewStats {
    return {
      totalProducts: r.totalProducts,
      totalRecentPitch: r.totalRecentPitch,
      recentCycle: r.recentCycle ? Cycle.fromResource(r.recentCycle) : undefined,
      nextCycle: r.nextCycle ? Cycle.fromResource(r.nextCycle) : undefined,
      totalNextCycle: r.totalNextCycle,
      voting: r.voting ? VotingStats.fromResource(r.voting) : undefined,
    };
  }
}
